<div class="eyeicon-scroll-container" style="padding-right: 1rem;"
  infiniteScroll [infiniteScrollDistance]="5" [scrollWindow]="false" [infiniteScrollThrottle]="1000" (scrolled)="onScrollDown()">

  <app-candidate-job-details class="candidateJobContent" *ngIf="(jobAppliedByTheUser | async)?.length > 0"
    [showInteractiveButton]="true" [contentType]="'JA'" [interactionResponse]="(jobAppliedByTheUser | async)"
    [cardContent]="'JA'" [page]="page" (nextPage)="pagecount($event)"></app-candidate-job-details>

  <app-common-skeleton *ngIf="loadAPIcall && (jobAppliedByTheUser | async)?.length > 0" [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>

  <div class="col-sm-12 gs-end-of-list" *ngIf="jobAppliedByTheUserStopScroll && (jobAppliedByTheUser | async)?.length > 0" style="text-align: center;padding-top: 1rem;">
    <div class="col-sm-12">
      <ng-icon name="tablerCircleCheck"></ng-icon>
    </div>
    <div class="col-sm-12">
      <p class="biase">You've reached the bottom of the page</p>
    </div>
  </div>

  <div class="col-12" *ngIf="loadAPIcall && (jobAppliedByTheUser | async)?.length == 0">
    <app-common-skeleton [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
  </div>

  <div class="col-sm-12" *ngIf="!loadAPIcall && (jobAppliedByTheUser | async)?.length == 0">
    <div class="gs-empty">
      <span class="gs-empty-icon"><ng-icon name="tablerBriefcase"></ng-icon></span>
      <div class="gs-empty-title">No jobs applied yet</div>
      <div class="gs-empty-sub">Jobs you apply to will show up here.</div>
    </div>
  </div>
</div>
